import type { ActivityCardConfig } from "./useActivityCards";

// Presentational only - useActivityCards.ts owns all status/copy/action
// logic. `data-activity` selects the per-card gradient/decorative icon in
// styles.css so the four cards read as distinct features, not four
// repaints of one template.
export function ActivityCard({ config }: { config: ActivityCardConfig }) {
  const { title, description, statusText, icon, status, badge, actionLabel, interactive, onActivate } = config;
  const isIdle = status === "idle";

  return (
    <button
      type="button"
      className={`activity-card${interactive ? "" : " is-informational"}`}
      data-activity={config.id}
      onClick={interactive ? onActivate : undefined}
      disabled={!interactive}
      aria-label={`${title} - ${statusText}`}
    >
      <i className={`bi ${icon} activity-card-decor`} aria-hidden="true" />
      <div className="activity-card-top">
        <span className="activity-card-icon">
          <i className={`bi ${icon}`} aria-hidden="true" />
        </span>
        {badge && <span className="activity-card-badge">{badge}</span>}
      </div>
      <div className="activity-card-body">
        <div className="activity-card-title">{title}</div>
        <div className="activity-card-status">{isIdle ? description : statusText}</div>
      </div>
      {interactive ? (
        <div className="activity-card-cta">
          {actionLabel} <i className="bi bi-arrow-right" aria-hidden="true" />
        </div>
      ) : (
        <div className="activity-card-cta is-informational-cta">{actionLabel}</div>
      )}
    </button>
  );
}
